module.exports = __webpack_public_path__ + "img/16_76.ba382fcd.png";